import { FormRow, FormSection } from 'framework/ui/layout';
import { DateInput, InputList } from 'framework/form';
import KpiParameterInputs from '../shared/inputs/KPIParameterInputs';
import { DATE_FORMAT } from 'framework/utils';

const ServiceKPIStructureForm = () => {
  return (
    <>
      <FormSection>
        <FormRow>
          <DateInput dateFormat={DATE_FORMAT.API_ONLY_MONTH} source="effectiveDate" label="Effective Date" isRequired />
        </FormRow>
      </FormSection>
      <FormSection>
        <InputList source="kpiParameters" inputTemplate={KpiParameterInputs} addText="Add parameter" maxFields={50} />
      </FormSection>
    </>
  );
};

export default ServiceKPIStructureForm;
